// The order of several cart items that is waiting for its payment, kept per guide so a reload or
// another tab carries on paying it instead of making a second one (the API refuses a second order
// for the same holds). Saved as { uuid, guestToken, cartToken, cartIds }. Never any payment details.
// Storage can be missing or blocked (private window, third-party iframe): the order then lives in
// memory only, for this visit.
const storageKey = (guideUuid) => `booking_widget_order_${guideUuid}`

export const readPendingOrder = (guideUuid) => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(storageKey(guideUuid)) || "null")
    return saved?.uuid && saved?.guestToken ? saved : null
  } catch (error) {
    return null
  }
}

export const savePendingOrder = (guideUuid, pendingOrder) => {
  try {
    window.localStorage.setItem(storageKey(guideUuid), JSON.stringify(pendingOrder))
  } catch (error) {
    // Nothing to do: the order is still paid in this visit.
  }
}

export const forgetPendingOrder = (guideUuid) => {
  try {
    window.localStorage.removeItem(storageKey(guideUuid))
  } catch (error) {
    // Nothing to do.
  }
}
